import { FC } from 'react';
import { Field, FastField } from 'formik';
import { IOption } from '@shared/interfaces';
import { FormFieldLabel } from '@styles/Shared/StyledFormFields';
import { Paths } from '@typings/global';
import { deCamelize } from '@shared/commonFunctions';
import { OptOutFormGridItem } from '@shared/styledComponents';
import { Note } from '@styles/ContactManager/TabsStyles';
import { ConsentPurposes } from '../../../../../constants';

export interface IOneTrustFormFieldConfig<T = object> {
  width?: string;
  name?: Paths<T> | string;
  label?: string;
  component?: FC<any>; // eslint-disable-line
  type?: string;
  tooltipMessage?: string;
  options?: IOption[];
  hidden?: boolean | false;
  [key: string]: unknown;
  onUpdate?: () => void;
  updateBtnLabel?: string;
  isSubForm?: boolean;
}

interface IFormFieldsProps<T = object> {
  config: IOneTrustFormFieldConfig<T>[];
  useFastFields?: boolean;
}

export const OptOutOneTrustForm = ({ config, useFastFields = false }: IFormFieldsProps) => {
  const fieldLabel = (name = '') => {
    const list = name.split('.');

    return deCamelize(list[list.length - 1]);
  };

  return (
    <>
      {config.map(({ width, minWidth, name, label, component, isSubForm, ...rest }, index) => (
        <>
          <OptOutFormGridItem
            key={index}
            width={width}
            minWidth={minWidth as string}
            isSubForm={isSubForm}
          >
            {rest?.type === 'other' ? (
              component
            ) : rest?.type === 'label' ? (
              <FormFieldLabel>{label || deCamelize(name)}</FormFieldLabel>
            ) : useFastFields ? (
              <FastField
                {...rest}
                name={name}
                label={label || fieldLabel(name)}
                component={component}
              />
            ) : (
              <>
                <Field
                  {...rest}
                  name={name}
                  label={label || fieldLabel(name)}
                  component={component}
                />
              </>
            )}
          </OptOutFormGridItem>
          {name === ConsentPurposes.APPLICATION && (
            <Note>Note:- For Active Loan Application Opt-Out Call and Email option will be reverted</Note>
          )}
        </>
      ))}
    </>
  );
};
